import { Icon } from "@mui/material";
import { useNavigate } from "react-router-dom";

import "../css/Collection.css";

type Props = {
  title?: string;
};

const CollectionTopbar = ({ title }: Props) => {
  const navigate = useNavigate();

  const goBack = () => {
    // Go back in history when we came from inside the app, otherwise to the home
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
    else navigate("/");
  };

  return (
    <div className="col-topbar">
      <button type="button" className="col-topbar__back" onClick={goBack} aria-label="Retour">
        <Icon>arrow_back</Icon>
      </button>
      {title ? <span className="col-topbar__title">{title}</span> : null}
    </div>
  );
};

export default CollectionTopbar;
